import { Card, CardActions, CardContent, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { alphanumericRegex } from 'shell/constants/regex';
import Form from './form';
import { noop } from 'shell/utils/noop';
import { BodyResearchResponsible } from 'practice/view-models/research-responsible';

const validationSchema = yup.object({
  practice: yup.string().nullable().required('Campo obbligatorio'),
  service: yup
    .string()
    .nullable()
    .matches(alphanumericRegex, 'Il campo è alfanumerico')
    .required('Campo obbligatorio'),
  responsible: yup
    .string()
    .nullable()
    .matches(alphanumericRegex, 'Il campo è alfanumerico')
    .required('Campo obbligatorio')
    .required('Campo obbligatorio'),
});

export interface FormResponsibleVM {
  practice?: string;
  service?: string;
  responsible?: string;
}

interface FormResponsibleProps {
  disabled?: boolean;
  title: string;
  isEdit?: boolean;
  responsible?: Array<BodyResearchResponsible>;
  onCancel: () => void;
  initialValues?: FormResponsibleVM;
  onSubmit?: (values: FormResponsibleVM) => void;
}

const FormResponsibleComponent = ({
  disabled,
  title,
  isEdit,
  onCancel,
  initialValues,
  onSubmit,
}: FormResponsibleProps): ReactElement => {
  const form = useFormik<FormResponsibleVM>({
    initialValues: initialValues || {
      practice: undefined,
      service: undefined,
      responsible: undefined,
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit || noop,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={form.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Form
              values={form.values}
              onChange={form.setFieldValue}
              disabled={disabled}
              touched={form.touched}
              isEdit={isEdit}
              errors={form.errors}
            />
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormResponsibleComponent.displayName = 'Form Responsible Page component';

const FormResponsible = memo(FormResponsibleComponent);

export default FormResponsible;
